import { api } from '@/utils/apiService';

const asData = async (promise) => {
  const response = await promise;
  if (response.status >= 400) {
    const err = response.data || {};
    throw Object.assign(new Error(err.message || 'request_failed'), {
      error: err.error,
      data: err,
      status: response.status,
    });
  }
  return response.data;
};

export const getPartnerProducts = () => asData(api.get('/partner/products'));
export const getPartnerStatus = () => asData(api.get('/partner/status'));
export const createPartnerSubscriptionCheckout = () => asData(
  api.post('/partner/subscription/checkout/session', {}),
);
export const pollPartnerSubscriptionCheckout = (sessionId) => asData(
  api.post('/partner/subscription/checkout/poll', { sessionId }),
);
export const cancelPartnerSubscription = () => asData(
  api.post('/partner/subscription/cancel', {}),
);
export const getPartnerPointsBalance = () => asData(api.get('/partner/points/balance'));
export const getPartnerPointsHistory = () => asData(api.get('/partner/points/history'));
export const createHighlightCheckout = (productKey, { specialId, startsAt } = {}) => asData(
  api.post('/partner/highlights/checkout/session', {
    productKey,
    specialId,
    startsAt,
  }),
);
export const pollHighlightCheckout = (sessionId) => asData(
  api.post('/partner/highlights/checkout/poll', { sessionId }),
);
export const cancelHighlightCheckout = (sessionId) => asData(
  api.post('/partner/highlights/checkout/cancel', sessionId ? { sessionId } : {}),
);
export const pollPartnerCheckout = (sessionId) => asData(
  api.post('/partner/checkout/poll', { sessionId }),
);
export const redeemHighlightWithPoints = (productKey, { specialId, startsAt } = {}) => asData(
  api.post('/partner/highlights/redeem-points', {
    productKey,
    specialId,
    startsAt,
  }),
);

export const getCommissionSummary = () => asData(api.get('/partner/commission/summary'));
export const getCommissionEvents = (params = {}) => asData(
  api.get('/partner/commission/events', { params }),
);
export const getPartnerInvoices = () => asData(api.get('/partner/invoices'));
export const getPartnerInvoiceDetail = (invoiceId) => asData(
  api.get(`/partner/invoices/${invoiceId}`),
);
export const downloadPartnerInvoicePdf = async (invoiceId) => {
  const response = await api.get(`/partner/invoices/${invoiceId}/pdf`, {
    responseType: 'blob',
  });
  if (response.status >= 400) {
    throw new Error('pdf_download_failed');
  }
  return response.data;
};
export const createInvoiceCheckout = (invoiceId) => asData(
  api.post(`/partner/invoices/${invoiceId}/checkout/session`, {}),
);
export const pollInvoiceCheckout = (sessionId) => asData(
  api.post('/partner/invoices/checkout/poll', { sessionId }),
);
